(function() {
  'use strict';

  const VERSION = '3.2.1';
  const cfg = window.__AI_CONFIG__ || {};
  const store = cfg.store || location.hostname;
  const pageType = cfg.pageType || 'other';

  function log(agent, msg) {
    console.log('[AI Agency] ' + agent + ': ' + msg);
  }

  function init() {
    log('System', '========================================');
    log('System', 'AI Agency Engine v' + VERSION);
    log('System', 'Store: ' + store);
    log('System', 'Page: ' + pageType);
    log('System', '========================================');
    runSEOAgent();
    runPerformanceAgent();
    runImageAgent();
    runAnalyticsAgent();
    runTechAgent();
    runUXAgent();
    runSchemaAgent();
  }

  function runSEOAgent() {
    log('SEO Agent', 'Starting...');
    if (!document.querySelector('link[rel="canonical"]')) {
      var c = document.createElement('link');
      c.rel = 'canonical';
      c.href = location.href.split('?')[0];
      document.head.appendChild(c);
      log('SEO Agent', 'Canonical URL set → ' + c.href);
    }
    var ogTags = {
      'og:title': document.title,
      'og:url': location.href,
      'og:type': pageType === 'product' ? 'product' : 'website',
      'og:site_name': cfg.shopName || ''
    };
    Object.keys(ogTags).forEach(function(prop) {
      if (!document.querySelector('meta[property="' + prop + '"]')) {
        var m = document.createElement('meta');
        m.setAttribute('property', prop);
        m.setAttribute('content', ogTags[prop]);
        document.head.appendChild(m);
      }
    });
    var fixed = 0;
    document.querySelectorAll('img:not([alt])').forEach(function(img) {
      img.alt = cfg.shopName || store;
      fixed++;
    });
    if (fixed) log('SEO Agent', 'Fixed ' + fixed + ' missing alt tags');
    log('SEO Agent', 'Done');
  }

  function runPerformanceAgent() {
    log('Performance Agent', 'Starting...');
    var count = 0;
    document.querySelectorAll('img:not([loading])').forEach(function(img) {
      img.loading = 'lazy';
      count++;
    });
    if (count) log('Performance Agent', 'Lazy loading applied to ' + count + ' images');
    document.querySelectorAll('a[href]').forEach(function(a) {
      a.addEventListener('mouseenter', function() {
        var href = a.getAttribute('href');
        if (href && href.startsWith('/') && !document.querySelector('link[rel="prefetch"][href="' + href + '"]')) {
          var l = document.createElement('link');
          l.rel = 'prefetch';
          l.href = href;
          document.head.appendChild(l);
        }
      }, { once: true });
    });
    log('Performance Agent', 'Done');
  }

  function runImageAgent() {
    log('Image Agent', 'Starting...');
    var converted = 0;
    document.querySelectorAll('img[src*="cdn.shopify.com"]').forEach(function(img) {
      var src = img.src;
      if (!src.includes('format=webp') && !src.includes('.webp')) {
        img.src = src + (src.includes('?') ? '&' : '?') + 'format=webp&quality=85';
        converted++;
      }
    });
    if (converted) log('Image Agent', 'WebP applied to ' + converted + ' images');
    log('Image Agent', 'Done');
  }

  function runAnalyticsAgent() {
    log('Analytics Agent', 'Starting...');
    var milestones = [10, 30, 60, 120];
    milestones.forEach(function(sec) {
      setTimeout(function() {
        log('Analytics Agent', sec + 's milestone on ' + pageType);
      }, sec * 1000);
    });
    var maxScroll = 0;
    window.addEventListener('scroll', function() {
      var pct = Math.round((window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100);
      if (pct > maxScroll) {
        maxScroll = pct;
        if ([25, 50, 75, 100].includes(maxScroll)) {
          log('Analytics Agent', 'Scroll depth: ' + maxScroll + '%');
        }
      }
    }, { passive: true });
    log('Analytics Agent', 'Tracking active');
  }

  function runTechAgent() {
    log('Tech Agent', 'Starting...');
    window.addEventListener('error', function(e) {
      log('Tech Agent', 'JS error caught - ' + e.message);
    });
    window.addEventListener('unhandledrejection', function(e) {
      log('Tech Agent', 'Unhandled promise rejection - ' + (e.reason || 'unknown'));
    });
    log('Tech Agent', 'Error monitoring active');
  }

  function runUXAgent() {
    log('UX Agent', 'Starting...');
    if ('PerformanceObserver' in window) {
      try {
        var lcp = new PerformanceObserver(function(list) {
          var entries = list.getEntries();
          var last = entries[entries.length - 1];
          var lcpTime = Math.round(last.startTime);
          var rating = lcpTime < 2500 ? 'Good' : lcpTime < 4000 ? 'Needs improvement' : 'Poor';
          log('UX Agent', 'LCP: ' + lcpTime + 'ms (' + rating + ')');
        });
        lcp.observe({ type: 'largest-contentful-paint', buffered: true });
      } catch(e) {}
    }
    log('UX Agent', 'Core Web Vitals monitoring active');
  }

  function runSchemaAgent() {
    log('Schema Agent', 'Starting...');
    var schemas = document.querySelectorAll('script[type="application/ld+json"]');
    log('Schema Agent', schemas.length + ' schema blocks found on page');
    log('Schema Agent', 'Done');
  }

  window.__AI_AGENCY__ = {
    version: VERSION,
    store: store,
    pageType: pageType,
    agents: ['SEO', 'Performance', 'Image', 'Analytics', 'Tech', 'UX', 'Schema']
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();